import axios from "axios";

import { auth } from "@Firebase/firebase";
import { Dealership } from "@Types/dealerships";
import { HttpQuery, PaginatedResult } from "@Types/http";

export const getDealers = (
  query?: HttpQuery
): (() => Promise<PaginatedResult<Dealership[]>>) => {
  return async () => {
    const token = await auth.currentUser?.getIdToken();

    const response = await axios.get(
      `${process.env.REACT_APP_HTTP_URL}/lender-api/v1/dealership/`,
      {
        headers: {
          authorization: `Bearer ${token}`,
          query:
            query && Object.keys(query)?.length
              ? JSON.stringify(query)
              : undefined,
        },
      }
    );

    return {
      docs: response.data.result?.docs ?? [],
      totalDocs: response.data.result?.totalDocs ?? 0,
      totalPages: response.data.result?.totalPages ?? 0,
    };
  };
};
export const getTopDealers = (
  query?: HttpQuery
): (() => Promise<PaginatedResult<Dealership[]>>) => {
  return async () => {
    const token = await auth.currentUser?.getIdToken();

    const response = await axios.get(
      `${process.env.REACT_APP_HTTP_URL}/lender-api/v1/dealers_dashboard_top_dealers/`,
      {
        headers: {
          authorization: `Bearer ${token}`,
          query:
            query && Object.keys(query)?.length
              ? JSON.stringify(query)
              : undefined,
        },
      }
    );

    return {
      docs: response.data.result?.docs ?? [],
      totalDocs: response.data.result?.totalDocs ?? 0,
      totalPages: response.data.result?.totalPages ?? 0,
    };
  };
};
export const getDealer = (id: string): (() => Promise<Dealership>) => {
  return async () => {
    const token = await auth.currentUser?.getIdToken();
    const response = await axios.get(
      `${process.env.REACT_APP_HTTP_URL}/lender-api/v1/dealership/${id}`,
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data.result;
  };
};
export const getNewDealers = (
  query?: HttpQuery
): (() => Promise<PaginatedResult<Dealership[]>>) => {
  return async () => {
    const token = await auth.currentUser?.getIdToken();

    const response = await axios.get(
      `${process.env.REACT_APP_HTTP_URL}/lender-api/v1/new-dealership/`,
      {
        headers: {
          authorization: `Bearer ${token}`,
          query:
            query && Object.keys(query)?.length
              ? JSON.stringify(query)
              : undefined,
        },
      }
    );

    return {
      docs: response.data.result?.docs ?? [],
      totalDocs: response.data.result?.totalDocs ?? 0,
      totalPages: response.data.result?.totalPages ?? 0,
    };
  };
};
